import { createAction } from '@reduxjs/toolkit';

import { CLEAR_ALL_PASSCODE_DIGITS, SET_PASSCODE_DIGIT, SetPasscodePayload } from './actions.types';


export const setPasscodeDigit = createAction(SET_PASSCODE_DIGIT,
    ({ key, value }: SetPasscodePayload) => ({ payload: { key, value } }));
export const clearAllPasscodeDigits = createAction(CLEAR_ALL_PASSCODE_DIGITS);
